import React from "react";

function Notfound (){
    return (
        <div>
            <h1>Not Found!</h1>
        </div>
    )
}


export default Notfound;